import { memo, useCallback } from 'react';

import { Ai } from '@air/next-icons';
import { Badge } from '@air/primitive-badge';
import { useAirModal } from '@air/provider-modal';

import { UpsellModal } from '~/components/v2/components/upsells/UpsellModal';
import { WorkspaceSidebarNavigationItem } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarNavigationItem';

export const WorkspaceSidebarNavigationItemUpsell = memo(() => {
  const [showUpsellModal] = useAirModal(UpsellModal);

  const onClick = useCallback(() => {
    showUpsellModal();
  }, [showUpsellModal]);

  return (
    <WorkspaceSidebarNavigationItem onClick={onClick}>
      <Ai className="size-4 shrink-0" />
      <span className="grow truncate">Unlock new features</span>
      <Badge appearance="pill" color="blue" size="small" className="shrink-0">
        NEW
      </Badge>
    </WorkspaceSidebarNavigationItem>
  );
});

WorkspaceSidebarNavigationItemUpsell.displayName = 'WorkspaceSidebarNavigationItemUpsell';
